import React, { useEffect } from 'react';
import { ReactQueryConfigProvider } from 'react-query';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { debounce } from 'throttle-debounce';
import { getIntlLocale } from '@/redux/selectors/intl';
import { getMobile } from '@/redux/selectors/mobile';
import { getTheme } from '@/redux/selectors/theme';
import AppMessage from '@/components/app/message';
import ErrorBoundary from '@/components/error/boundary';
import FullScreenProvider from '@/components/full-screen/provider';
import StyledApp from './styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var setPropertyVh = debounce(100, false, function () {
  var vh = window.innerHeight * 0.01;

  if (document.documentElement) {
    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
  }
});

var setMetaViewport = function setMetaViewport(isMobile) {
  var _metaViewportEl$getAt;

  var metaViewportEl = document.querySelector('meta[name="viewport"]');
  if (!metaViewportEl) return;
  var parameters = ((_metaViewportEl$getAt = metaViewportEl.getAttribute('content')) !== null && _metaViewportEl$getAt !== void 0 ? _metaViewportEl$getAt : '').split(',').map(function (v) {
    return v.trim();
  });

  if (isMobile) {
    parameters.push('user-scalable=no');
  }

  metaViewportEl.setAttribute('content', parameters.join(','));
};

var reactQueryDefaultConfig = {
  queries: {
    refetchOnWindowFocus: false,
    useErrorBoundary: true
  }
};

var App = function App(_ref) {
  var children = _ref.children;
  var intlLocale = useSelector(getIntlLocale);
  var mobile = useSelector(getMobile);
  var theme = useSelector(getTheme);

  var componentDidMount = function componentDidMount() {
    if (true) {
      /* eslint-disable no-underscore-dangle */
      window.__APP_MOUNT_TIME_END = performance.now();
      /* eslint-enable no-underscore-dangle */

      window.addEventListener('resize', setPropertyVh);
      setPropertyVh();
      document.documentElement.setAttribute('lang', intlLocale);
      setMetaViewport(Boolean(mobile));
    }
  };

  useEffect(componentDidMount, []);
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(FullScreenProvider, {
      children: /*#__PURE__*/_jsx(ReactQueryConfigProvider, {
        config: reactQueryDefaultConfig,
        children: /*#__PURE__*/_jsx(StyledApp, {
          children: /*#__PURE__*/_jsxs(ErrorBoundary, {
            children: [/*#__PURE__*/_jsx(AppMessage, {
              scope: "app",
              command: "ready"
            }), children]
          })
        })
      })
    })
  });
};

export default App;